import { render, staticRenderFns } from "./WelcomeContent.vue?vue&type=template&id=097ba1a8"
import script from "./WelcomeContent.vue?vue&type=script&lang=js"
export * from "./WelcomeContent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeContent.vue?vue&type=style&index=0&id=097ba1a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports